import React from 'react';

const ExamResults = ({ exams }) => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg">
      <h2 className="text-2xl font-semibold text-primary mb-6">
        Exames e Resultados
      </h2>
      <ul className="space-y-6">
        {exams.length > 0 ? (
          exams.map((exam, index) => (
            <li
              key={index}
              className="p-4 bg-gray-50 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              <p className="text-lg font-medium text-gray-800 mb-2">
                <strong>Tipo de Exame:</strong> {exam.type}
              </p>
              <p className="text-gray-600">
                <strong>Resultado:</strong> {exam.result}
              </p>
              <p className="text-gray-600">
                <strong>Data:</strong> {exam.date}
              </p>
              <p className="text-gray-600">
                <strong>Médico:</strong> {exam.doctor || 'Não informado'}
              </p>
              <p className="text-gray-600">
                <strong>Laboratório:</strong> {exam.lab || 'Não informado'}
              </p>
            </li>
          ))
        ) : (
          <li className="p-4 bg-gray-50 rounded-lg shadow-md">
            <p className="text-gray-600">Nenhum exame encontrado.</p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ExamResults;
